import {
  Component,
  ChangeDetectionStrategy,
  OnDestroy,
  OnInit,
  ChangeDetectorRef,
  Inject,
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslationService } from './modules/i18n/translation.service';
// language list
import { locale as enLang } from './modules/i18n/vocabs/en';
import { locale as arLang } from './modules/i18n/vocabs/ar';
import { locale as esLang } from './modules/i18n/vocabs/es';
import { locale as jpLang } from './modules/i18n/vocabs/jp';
import { locale as deLang } from './modules/i18n/vocabs/de';
import { locale as frLang } from './modules/i18n/vocabs/fr';
import { SplashScreenService } from './_metronic/partials/layout/splash-screen/splash-screen.service';
import { TableExtendedService } from './_metronic/shared/crud-table';
import { NgbProgressbarConfig } from '@ng-bootstrap/ng-bootstrap';
import { AuthHTTPService } from './modules/auth/_services/auth-http';
import { AuthService } from './modules/auth';
import { DOCUMENT } from "@angular/common";
import { SmsService } from "./modules/shared/services/sms.service";
import { RolesService } from "./modules/settings/website-setting/components/roles/_services/roles.service";


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [NgbProgressbarConfig],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  showBar = false;
  private authData = this._service.getAuthFromLocalStorage();
  constructor(
    private translationService: TranslationService,
    private splashScreenService: SplashScreenService,
    private router: Router,
    private tableService: TableExtendedService,
    config: NgbProgressbarConfig,
    private _service: AuthService,
    private _AuthHTTPService: AuthHTTPService,
    private _roulesService: RolesService,
    @Inject(DOCUMENT) private document: Document
  ) {
    // customize default values of progress bars used by this component tree
    config.max = 30;
    config.striped = true;
    config.animated = true;
    config.type = 'success';
    config.height = '20px';
    // register translations
    // register translations
    this.translationService.loadTranslations(
      enLang,
      arLang,
    );

    if (!localStorage.getItem('exspireIn')) {
      localStorage.setItem('exspireIn', '0')

    }
  }

  ngOnInit() {
    this.changeDire('ar');
    let currentLang = localStorage.getItem('language') ? localStorage.getItem('language') : 'ar';
        this.translationService.setLanguage(currentLang);
    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // clear filtration paginations and others
        this.tableService.setDefaults();
        // hide splash screen
        this.splashScreenService.hide();

        // scroll to top on every route change
        window.scrollTo(0, 0);

        // to display back the body content
        setTimeout(() => {
          document.body.classList.add('page-loaded');
        }, 500);
      }
    });
    this.getUserData();
    this.unsubscribe.push(routerSubscription);
  }

  // Get user data (To fix reload issue when update user permission)
  getUserData() {
    if (this.authData) {
      this._AuthHTTPService.getUserProfile(this.authData.accessToken).subscribe(userData => {
        this._roulesService.SetUserPermission(userData.item.permissions)
      })
    }
  }

  changeDire(lang){
    const htmlTag = this.document.getElementsByTagName(
      "html"
    )[0] as HTMLHtmlElement;
    htmlTag.dir = lang === "ar" ? "rtl" : "ltr";
    htmlTag.lang = lang;
    htmlTag.setAttribute("direction", `${lang === "ar" ? "rtl" : "ltr"}`);
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
